/**
 * 独立弹窗组件
 * @description
 * 适用于不需要控制全局关闭的弹窗
 *
 **/

import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useDialogKeyboard, DialogKeyboardConfig } from 'lib/hooks/useDialogKeyboard';
import './index.scss';

interface DialogProps {
  title?: string | ReactElement;
  children: ReactElement;
  confirmButtonText?: string;
  closeButtonText?: string;
  customClass?: string;
  showClose?: boolean;
  showConfirm?: boolean;
  bottomText?: string;
  confirmCallback?: () => void;
  closeCallback?: () => void;
  closeOnConfirm?: boolean;
  closeModal?: () => void;
  keyboard?: DialogKeyboardConfig;
}

const IndependentDialog = ({
  title,
  children,
  showClose = true,
  showConfirm = true,
  confirmButtonText = '',
  closeButtonText = '',
  customClass = '',
  bottomText = '',
  confirmCallback,
  closeCallback,
  closeOnConfirm = true,
  closeModal,
  keyboard,
}: DialogProps) => {
  const closeDialog = () => {
    closeModal?.();
    closeCallback?.();
  };

  const confirm = () => {
    if (closeOnConfirm) {
      closeModal?.();
    }
    confirmCallback?.();
  };

  useDialogKeyboard({
    onEnter: keyboard?.onEnter ?? (showConfirm ? confirm : false),
    onEscape: keyboard?.onEscape ?? (showClose ? closeDialog : false),
    allowEnterInInput: keyboard?.allowEnterInInput,
  });

  return (
    <div className={classNames('independent-modal-dialog', customClass)}>
      {showClose ? <div className="independent-modal-dialog__close" onClick={closeDialog}></div> : null}
      {title ? <div className="independent-modal-dialog__title">{title}</div> : null}
      {children}
      <div className="independent-modal-dialog__footer">
        {closeButtonText ? (
          <div className="independent-modal-dialog__footer--btn close" onClick={closeDialog}>
            {closeButtonText}
          </div>
        ) : null}
        {showConfirm ? (
          <div className="independent-modal-dialog__footer--btn confirm" onClick={confirm}>
            {confirmButtonText || '我知道了'}
          </div>
        ) : null}
      </div>
      {bottomText ? (
        <div className="independent-modal-dialog__bottomText">
          <div>{bottomText}</div>
        </div>
      ) : null}
    </div>
  );
};

export default IndependentDialog;
